import React, { useState } from 'react';

const MediaModal = ({ show, imageUrl, attachmentType, onClose }) => {
  const [loading, setLoading] = useState(true);
  if (!show || !imageUrl) return null;

  return (
    <>
      <div className="modal show d-flex align-items-center justify-content-center position-fixed w-100 h-100" tabIndex="-1" role="dialog" style={{ zIndex: 1050, backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
        <div
          className="modal-dialog d-flex align-items-center justify-content-center"
          role="document"
          style={{
            maxWidth: '90vw',
            maxHeight: '90vh',
          }}
        >
          <div className="bg-transparent border-0 modal-content d-flex align-items-center justify-content-center position-relative">
            <button
              type="button"
              className="btn btn-outline-light rounded-circle"
              style={{
                width: '40px',
                height: '40px',
                fontSize: '1.5rem',
                backgroundColor: 'rgba(255, 255, 255, 0.3)',
                border: 'none',
                color: 'white',
                backdropFilter: 'blur(8px)',
                position: 'absolute',
                top: '10px',
                right: '15px',
                zIndex: 1060,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: '0.3s',
                cursor: 'pointer',
              }}
              onClick={onClose}
              aria-label="Close"
            >
              ✕
            </button>

            <div
              className="modal-body d-flex align-items-center justify-content-center"
              style={{
                width: '100vw',
                height: '100vh',
              }}
            >
              {attachmentType === 4 ? (
                <video
                  controls
                  className="img-fluid"
                  style={{
                    borderRadius: '12px',
                    maxHeight: '85vh',
                    maxWidth: '80vw',
                    objectFit: 'contain',
                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.2)',
                  }}
                >
                  <source src={imageUrl} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              ) : (
                <>
                  {loading && (
                    <div
                      className="text-white spinner-border"
                      style={{
                        width: '120px',
                        height: '120px',
                        position: 'absolute',
                      }}
                      role="status"
                    ></div>
                  )}

                  <img
                    src={imageUrl}
                    alt="Attachment Preview"
                    className="img-fluid"
                    style={{
                      borderRadius: '12px',
                      maxHeight: '85vh',
                      maxWidth: '80vw',
                      objectFit: 'contain',
                      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.2)',
                      visibility: loading ? 'hidden' : 'visible',
                      opacity: loading ? 0 : 1,
                      transition: 'opacity 0.3s ease-in-out',
                    }}
                    onLoad={() => setLoading(false)}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop show position-fixed w-100 h-100" style={{ zIndex: 1040, backgroundColor: 'rgba(0, 0, 0, 0.5)' }} onClick={onClose}></div>
    </>
  );
};

export default MediaModal;
